var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMachineLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 120,
    viewBox: "0 0 104 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vu776t7dya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 52",
    transform: "translate(0 .045)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h46v50H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9417"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 40",
    style: {
      fill: "#cf422c"
    },
    d: "M0 0h104v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39",
    transform: "translate(29.001 35.955)",
    style: {
      clipPath: "url(#vu776t7dya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "M11.63 5.57a4.058 4.058 0 1 0 4.058 4.058A4.057 4.057 0 0 0 11.63 5.57",
    transform: "translate(14.358 9.831)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M25.546 0A19.812 19.812 0 0 0 5.738 18.843L.289 26.108a1.418 1.418 0 0 0 1.135 2.27h4.257v8.514a5.692 5.692 0 0 0 5.676 5.676h2.838v8.514h19.864V37.8A19.857 19.857 0 0 0 25.546 0m8.514 19.865c0 .369-.028.738-.057 1.107l2.355 1.873a.532.532 0 0 1 .142.709L34.23 27.5a.57.57 0 0 1-.681.255L30.74 26.62a8.528 8.528 0 0 1-1.9 1.107l-.454 3.008a.556.556 0 0 1-.568.482h-4.542a.577.577 0 0 1-.568-.482l-.426-3.008a8.117 8.117 0 0 1-1.93-1.107l-2.809 1.135a.6.6 0 0 1-.709-.255l-2.27-3.945a.538.538 0 0 1 .142-.709l2.384-1.873c-.028-.369-.057-.738-.057-1.107a6.961 6.961 0 0 1 .114-1.107l-2.412-1.873a.562.562 0 0 1-.142-.738l2.27-3.916a.559.559 0 0 1 .681-.255l2.838 1.135a9.009 9.009 0 0 1 1.9-1.112l.426-3a.577.577 0 0 1 .568-.482h4.541a.577.577 0 0 1 .567.482l.425 3a8.528 8.528 0 0 1 1.9 1.107l2.838-1.135a.547.547 0 0 1 .681.255l2.27 3.916a.568.568 0 0 1-.142.738l-2.412 1.873a4.572 4.572 0 0 1 .114 1.107",
    transform: "translate(.442 -.406)",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineLearning);
export default __webpack_public_path__ + "static/media/machine-learning.55dee2cdde96573878d29d6fe77adb18.svg";
export { ForwardRef as ReactComponent };